import type { FC } from 'react'
import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'

import DemoForm from '@segment/templates/Forms/DemoForm'

import { trackProgramSignupForm } from '@segment/tracking/scripts'

import heroPng2x from './assets/Hero@2x.png'
import heroWebp from './assets/Hero.webp'
import heroWebp2x from './assets/Hero@2x.webp'

const copy = {
  overline: `CustomerAI Personalization Engine`,
  heading: `Personalize every LLM-powered conversation with your customer data`,
  description: `Infuse greater customer understanding and personalization into every customer interaction with a seamless API connection between your Segment customer data and ChatGPT or other large language models (LLMs).`,
}

const Hero: FC = () => {
  return (
    <Wrapper>
      <HeroBase variant="2Col">
        <HeroRecipe.Copy>
          <CopyTextBase>
            <CopyText.Overline variant="h5" tag="p">
              {copy.overline}
            </CopyText.Overline>
            <CopyText.Heading variant="h1" tag="h1">
              {copy.heading}
            </CopyText.Heading>
            <CopyText.Description variant="pExtraLarge" tag="p">
              {copy.description}
            </CopyText.Description>
            <HeroRecipe.Form>
              <DemoForm
                isProgressive={true}
                customFormIdentifier="customerai-personalization-beta-request"
                customTrackingType="customerai-personalization-beta-request"
                successMessageAppearance="twilioLight"
                buttonText="Join the Beta"
                isLeadEnrichmentFormEnabled={false}
                onSubmit={(data) => {
                  trackProgramSignupForm(data)
                }}
                successMessage={{
                  heading: `You’re all set!`,
                  description: `Thank you for submitting your request to join the beta! A member of the Segment team will be in touch.`,
                  buttonText: null,
                }}
              />
            </HeroRecipe.Form>
          </CopyTextBase>
        </HeroRecipe.Copy>

        <HeroRecipe.Contents>
          <picture>
            <source type="image/webp" srcSet={`${heroWebp}, ${heroWebp2x} 2x`} />
            <HeroRecipe.Image width="645" height="506" src={heroPng2x} alt="" loading="lazy" />
          </picture>
        </HeroRecipe.Contents>
      </HeroBase>
    </Wrapper>
  )
}

const Wrapper = styled.header`
  background-color: ${({ theme }) => theme.palette.twilio.green[10]};
`

export default Hero
